<template>
  <el-tooltip
      v-model="visible"
      :placement="placement"
      :effect="effect"
      transition="">
    <div slot="content">
      <ul class="operation-tooltip-list">
        <template v-for="(item, index) in list">
          <li v-if="showItem(item)"
              :key="index">
            <el-button
                :disabled="disabledItem(item)"
                type="text"
                @click="onClick(item)">
              {{ item.title }}
            </el-button>
          </li>
        </template>
      </ul>
    </div>
    <el-button
        :disabled="disabledAllItem"
        class="operation-tooltip"
        type="text">
      <i class="el-icon-more" />
    </el-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'BaseOperationTooltip',
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    effect: {
      type: String,
      default: 'light'
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    disabledAllItem () {
      return this.list.findIndex(element => {
        if (!this.showItem(element)) {
          return false
        }
        return !this.disabledItem(element)
      }) === -1
    }
  },
  methods: {
    showItem (item) {
      if (item.show == null) {
        return true
      }
      return typeof item.show === 'function' ? item.show() : item.show
    },
    disabledItem (item) {
      if (item.disabled == null) {
        return false
      }
      return typeof item.disabled === 'function' ? item.disabled() : item.disabled
    },
    onClick (item) {
      this.visible = false
      if (typeof item.click === 'function') {
        setTimeout(() => {
          item.click(item)
        }, 20)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseOperationTooltip.vue